import React, { useEffect } from "react";
import axios from "axios";

const envjs = "https://accounts.trueid.net";
declare var TID: any;
declare var $: any;

export type UserContextType = {
  user: User | null;
  isLoading: boolean;
  login: () => void;
  logout: () => void;
  lang: String;
  setLang: (lang: String) => void;
};

declare global {
  interface Window {
    idAsyncInit: any;
  }
}

type ProfileResponse = {
  uid: string;
  access_token: string;
  status: string;
};

type UserResponse = {
  data: User;
};

type LoginResponse = {
  access_token: string;
  status: string;
  profile: LoginProfile;
};

type LoginProfile = {
  display_name: string;
  uid: string;
};

type Profile = {
  ssoid: string;
  access_token: string;
  status: string;
};

export type User = {
  profile: Profile;
  id: string;
  display_name: string;
  avatar: string;
};

export const AuthContext = React.createContext<UserContextType | null>(null);
AuthContext.displayName = "AuthContext";

export function AuthProvider(props: any) {
  const [user, setUser] = React.useState<User | null>(null);
  const [lang, setLang] = React.useState<String>("th");
  const [isLoading, setLoading] = React.useState<boolean>(true);
  React.useEffect(() => {
    console.log('start id asyncInit')
      window.idAsyncInit = function (event: any) {
        TID.init({
          clientID: 29,
          version: 1.1,
          redirect_uri: "https://truevisions.co.th",
          state: "111",
        });

        TID.getstatus(async function (response: ProfileResponse) {
          if (response.status === "connected") {
            // connected
            //getprofile(response);
            const profile: Profile = {
              ssoid: response.uid,
              access_token: response.access_token,
              status: response.status,
            };

            let domain = window.location.hostname;
            if (domain !== "localhost") {
              //domain = "cms-truevisions.tanawat.dev";
              domain = "cms.truevisions.co.th"
            }
            let host = `${window.location.protocol}//${domain}`;
            if (
              window.location.port !== "80" &&
              window.location.port !== "443"
            ) {
              host += `:${window.location.port}`;
            }
            try {
              const result: UserResponse = await axios.get(
                `${host}/api/profile?access_token=${profile.access_token}&ssoid=${profile.ssoid}`
              );
              setUser({
                ...result.data,
                profile: profile,
              });
            } catch (error) {
              console.log(error);
              if (profile) {
                setUser({
                  profile: profile,
                  id: "",
                  display_name: "",
                  avatar: "",
                });
              }
            }
          } else {
          }
          setLoading(false);
        });

        $("#login").click(function () {
          TID.login(function (response: any) {
            console.log("login success.");
          });
        });
      };
  }, []);

  const login = () => {
    TID.login(async function (response: LoginResponse) {
      console.log("login");
      const profile: Profile = {
        access_token: response.access_token,
        status: response.status,
        ssoid: response.profile.uid,
      };

      let domain = window.location.hostname;
      if (domain !== "localhost") {
        //domain = "cms-truevisions.tanawat.dev";
        domain = "cms.truevisions.co.th"
      }
      let host = `${window.location.protocol}//${domain}`;
      if (window.location.port !== "80" && window.location.port !== "443") {
        host += `:${window.location.port}`;
      }

      try {
        const result: UserResponse = await axios.get(
          `${host}/api/profile?access_token=${profile.access_token}&ssoid=${profile.ssoid}`
        );
        setUser({
          ...result.data,
          profile: profile,
        });
      } catch (error) {
        console.log(error);
        if (profile) {
          setUser({
            profile: profile,
            id: "",
            display_name: "",
            avatar: "",
          });
        }
      }
    });
  };

  const updateLang = (newLang: string) => {
    setLang(newLang);
    localStorage.setItem("lang", newLang);
  };

  useEffect(() => {
    const lang = localStorage.getItem("lang");
    if (lang) {
      setLang(lang);
    }
  }, []);

  const value = { user, logout, login, isLoading, lang, setLang: updateLang };
  return <AuthContext.Provider value={value} {...props} />;
}

function logout() {
  window.location.href = envjs + "/signout?client_id=29";
}
